import React from 'react'
import { FaWhatsapp } from "react-icons/fa";


const WhatsappFloat = () => {
  return (
    <div>
         <a
       href="https://wa.me/919540403955"  
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp />
    </a>
    </div>
  )
}

export default WhatsappFloat